import { withUser } from 'components/queries/GetUserQuery';
import { withRouter } from 'react-router';
import ClubEurostarMember from './ClubEurostarMember';

export default withRouter(withUser(ClubEurostarMember));
